import React from 'react';
import { CloseIcon, Modal } from '../../components';
import RequestRevitForm from './requestRevitForm';

var RequestRevitModal = function RequestRevitModal(_ref) {
  var closeModal = _ref.closeModal,
      isOpen = _ref.isOpen;
  return React.createElement(Modal, {
    isOpen: isOpen,
    size: "full",
    toggleModal: closeModal,
    classes: {
      modalWrapper: 'bg-bronze'
    }
  }, React.createElement("div", {
    className: "bg-bronze px-4 h-full"
  }, React.createElement("div", {
    className: "flex justify-end pt-6"
  }, React.createElement("button", {
    onClick: closeModal,
    "aria-label": "Close"
  }, React.createElement(CloseIcon, {
    isWhite: true
  }))), React.createElement("p", {
    className: "text-white leading-178 px-6 text-center mb-4"
  }, "REQUEST REVIT OR CAD FILES ", React.createElement("br", null), " Please fill out the form below"), React.createElement(RequestRevitForm, null)));
};

export default RequestRevitModal;